import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import httpRequest from "../utils/httpRequest";
import InvoiceTable from "./InvoiceTable";
import CreditNoteInvoiceTable from "./CreditNoteTable";
import InvoiceFilters from "./InvoiceFilters";

const CreditNote = () => {
  const [invoices, setInvoices] = useState([]);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const fetchInvoices = async (page, pageSize) => {
    setLoading(true);
    try {
      const invoiceData = await httpRequest(
        "credit_note/getAllCNData",
        "GET",
        {},
        { page, pageSize, ...filters }
      );
      setInvoices(invoiceData);
    } catch (err) {
      setError("Failed to fetch invoices");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoices(page, pageSize);
  }, [page, pageSize]);

  const handleApplyFilters = () => {
    setPage(1);
    fetchInvoices();
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        marginTop: 2,
        width: "100%",
      }}
    >
      <Typography variant="h4" gutterBottom>
        Credit Note Invoice Management
      </Typography>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div></div>
      </Box>
      <InvoiceFilters
        filters={filters}
        setFilters={setFilters}
        onApply={handleApplyFilters}
        sx={{ width: "100%" }}
      />
      {loading ? (
        <Typography variant="h6">Loading...</Typography>
      ) : error ? (
        <Typography variant="h6" color="error">
          {error}
        </Typography>
      ) : (
        <CreditNoteInvoiceTable
          invoices={invoices}
          setPageSize={setPageSize}
          setPage={setPage}
          pageSize={pageSize}
          page={page}
        />
      )}
      {dialogLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <CircularProgress />
        </Box>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreditNote;
